import React, { FC, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
// import FixedDepartureHero from "./components/FixedDepartureHero";
// import FixedDepartureCardGrid from "./components/FixedDepartureCardGrid";
import OneDayTourCardGrid from "./components/OneDayTourCardGrid";

import OneDayTourHero from "./components/OneDayTourHero";
import { getOneDayToursByCity } from "services/apiServices";

import { useLocation } from 'react-router-dom';
import SectionSubHero from "components/SectionSubHero";
import LoadingSpinner from "components/LoadingSpinner";

export interface OneDayTourPageProps {
  className?: string;
}


const OneDayTourPage: FC<OneDayTourPageProps> = ({ className = "" }) => {


  const [oneDayTourData, setOneDayTourData] = useState<any>([]);
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const props = location.state;

  const fetchFixedDepartureData = async () => {
    try {
      setLoading(true)
      const response = await getOneDayToursByCity({ city: props.city, country: props.country })

      if (response.data) {
        let oDayTempData: any = [];
        if (response.data.response === "success") {
          console.log("oday Data", response.data)
          response.data.oneDayTour.map(async (item: any, key: number) => {
            oDayTempData[key] = {
              id: item.id,
              package_name: item.package_name,
              profileImg: item.image,
              seats: item.available_seats
            }
            console.log("xxxx", oDayTempData)
            setOneDayTourData(oDayTempData)
          })
        }
      }
    } catch (error) {

    }finally {  
      setLoading(false)
    }


  }


  useEffect(() => {
    fetchFixedDepartureData()
  }, [])

  return (
    <div
      className={`nc-OneDayTourPage relative overflow-hidden ${className}`}
      data-nc-id="OneDayTourPage"
    >
      <Helmet>
        <title>ONE DAY TOURS | EUROPE TOURS & TRAVELS</title>
      </Helmet>

      {/* <OneDayTourHero /> */}
      <SectionSubHero
        title="One Day Tours"
        pillTitle="Day Trip"
        bgClass="dashboard-odt-bg"
        description="Discover top attractions in a single day with a well-planned, enjoyable guided tour."
        className="pl-6 pt-10 lg:pt-10 lg:pb-10 mb-16"
      />

      <div className="container relative  mt-4 md:mt-0 lg:mt-0 xl:mt-0">

        {loading && <LoadingSpinner text="Loading Tour Details..." />}

        {oneDayTourData.length > 0 &&
          <OneDayTourCardGrid
            data={oneDayTourData}
            className="pb-24 lg:pt-32 lg:pb-16" />
        }

      </div>

    </div>
  );
};



export default OneDayTourPage
